import { ArrowUpFromLine } from "lucide-react";
import { AgentDocument } from "@/entities/agent/model/agent.types";

export default function MultipleFilesUploader({
  label,
  labelClassName,
  onFileAdd,
  itemIndex,
  accept = "",
  disabled,
}: {
  label: string;
  labelClassName: string;
  documents: AgentDocument[];
  onFileAdd: (document: File[], disabled: boolean) => void | Promise<void>;
  onFileRemove: (file: AgentDocument, index: number) => void | Promise<void>;
  itemIndex: number;
  accept: string;
  disabled: boolean;
}) {
  return (
    <div
      className={
        "flex h-[60px] w-full flex-col items-center justify-center gap-[10px] rounded-md bg-primary py-[16px] transition-all hover:opacity-90"
      }
    >
      <label
        className={
          "flex w-full cursor-pointer items-center justify-center gap-[10px]"
        }
        style={{ width: "100%" }}
        htmlFor={`file-uploader-${itemIndex}`}
      >
        <div className={"text-white"}>
          <ArrowUpFromLine />
        </div>

        <div className={labelClassName}>{label}</div>
        <input
          disabled={disabled}
          accept={accept}
          id={`file-uploader-${itemIndex}`}
          type="file"
          className={"hidden"}
          name={`file-uploader-${itemIndex}`}
          multiple
          onChange={async (e) => {
            const filesArray = Array.from(e.target.files ?? []);

            onFileAdd(filesArray, disabled);
          }}
        />
      </label>
    </div>
  );
}
